export default "__VITE_ASSET__C755AUpI__"